import "./hoverOption.scss";
import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import { Popover, Tooltip } from "antd";
import { ChatService } from "../../../../base/chatService";
import { useSelector } from "react-redux";
import { chats, chatwindowDetails, initialStateModel, LoginState } from "../../../../models/model";
import { Types } from "../../../../context/action/action";
import store from "../../../../context/store/store";
import { SocketChatService } from "../../../../base/socketChatService";
import { compressed_img, Cookie, downloadAttachment, strickerFormat } from "../../../../base/utils";
import { chatSideWindow } from "../../../../base/eventService/eventApiService";
import { toastInformation } from "../../../../base/callService/common";



type chatHoverOptionProps = {
  data?: any;
  className: string;
  multiFile?: any;
  highlightHover?: any;
  replyHover?: any;
};
export default function ChatHoverOption(props: chatHoverOptionProps) {
  let { className, data, multiFile, ...restProps } = props;
  let isBookmark: any = data?.message?.isSave || [];
  let LikeObeject: any = data?.message?.liked || [];
  //const [visible, setVisible] = useState(false);
  const [hovervisible, setHoverVisible] = useState(false);
  const socketService = useRef<any>(null);
  const chatReducer: chats = useSelector((state: initialStateModel) => state.chatReducer);
  const { userdetails }: LoginState = useSelector((state: initialStateModel) => state.loginReducer);
  let isLike = (LikeObeject && LikeObeject["s" + userdetails.sip_login_id]) || 0;
  let savedBookmark = (isBookmark && isBookmark["s" + userdetails.sip_login_id]) || 0;
  const chatWindowDetailReducer: chatwindowDetails = useSelector((state: initialStateModel) => state.chatWindowReducer);
  let { chatWindowDetails,isMySpace, isNewMessageWindow } = chatWindowDetailReducer;

  useEffect(() => {
    const userInfo: any = Cookie.get();
    const userInfosess: any = sessionStorage.getItem("userinfo");
    if (userInfosess) {
      const cookieData = JSON.parse(userInfosess);
      socketService.current = new SocketChatService(cookieData.sip_login_id, cookieData.domain_id);
    }
  }, []);
  const openEditWindow = () => {
    if (!chatReducer?.isDelete && !chatReducer?.isForward) {
      let editdetails = {
        id: data,
        text: data?.message?.body
      };
      ChatService.onChangeEditWindow(true, editdetails);
    }

    let hoverdiv: HTMLElement | any = document.getElementById("frezsec") || null;

    let hoverelement: HTMLElement | any = document.getElementById(data.id) || null;

    if (hoverelement != null) {
      hoverelement.classList.remove("highlighthover");
    }

    setHoverVisible(false);

    if (hoverdiv) hoverdiv.style["display"] = "none";

    let element: HTMLElement | any = document.getElementById("chatWindow") || null;

    if (element != null) {
      if (element.hasAttribute("scroll") === true) {
        element.removeAttribute("scroll");
        element.style["overflow-y"] = "overlay";
      }
    }
  };

  const openReplyMessage = () => {
    if (!chatReducer?.isDelete && !chatReducer?.isForward) {
      ChatService.onChangeReplyWindow(true, data);
    }
    let hoverdiv: HTMLElement | any = document.getElementById("frezsec") || null;

    let hoverelement: HTMLElement | any = document.getElementById(data.id) || null;

    if (hoverelement != null) {
      hoverelement.classList.remove("highlighthover");
    }

    setHoverVisible(false);

    if (hoverdiv) hoverdiv.style["display"] = "none";

    let element: HTMLElement | any = document.getElementById("chatWindow") || null;

    if (element != null) {
      if (element.hasAttribute("scroll") === true) {
        element.removeAttribute("scroll");
        element.style["overflow-y"] = "overlay";
      }
    }
  };

  const selectMessage = ()=>{
 
    if (!chatReducer?.isDelete && !chatReducer?.isForward) {
      console.log(chatReducer,"chatReducer")
      //ChatService.onChangeDeleteWindow(true,'all');
      ChatService.onMultiOptionWindow(true);
      //ChatService.onChangeForwardWindow(true,'all');
      //if (data.direction === "OUT") {
        let deletedArray: any = Array.isArray(chatReducer?.selectMessageData) ? chatReducer?.selectMessageData : [];
        deletedArray?.push(data);
        let fileArray: any =
        ( data?.message?.messageType === "IMAGE" && data.message.body.fileType !== "image/webp") 
        ||  (data?.message?.messageType === "FILE" && data.message.body.fileType !== "video/mp4" ) ? multiFile : deletedArray;
        store.dispatch({
          type: Types.SELECT_MESSAGE_ARRAY,
          payload: {
            selectMessageData: fileArray
          }
        });
      //}
    }
    let hoverdiv: HTMLElement | any = document.getElementById("frezsec") || null;

    let hoverelement: HTMLElement | any = document.getElementById(data.id) || null;

    if (hoverelement != null) {
      hoverelement.classList.remove("highlighthover");
    }

    setHoverVisible(false);

    if (hoverdiv) hoverdiv.style["display"] = "none";

    let element: HTMLElement | any = document.getElementById("chatWindow") || null;

    if (element != null) {
      if (element.hasAttribute("scroll") === true) {
        element.removeAttribute("scroll");
        element.style["overflow-y"] = "overlay";
      }
    }
  }
  const deleteMessage = () => {
    if (!chatReducer?.isDelete && !chatReducer?.isForward) {
      ChatService.onChangeDeleteWindow(true,'single');
      if (data.direction === "OUT") {
        let deletedArray: any = Array.isArray(chatReducer?.selectMessageData) ? chatReducer?.selectMessageData : [];
        deletedArray?.push(data);
        let fileArray: any =
        ( data?.message?.messageType === "IMAGE" && data.message.body.fileType !== "image/webp")  || data?.message?.messageType === "FILE" ? multiFile : deletedArray;
        store.dispatch({
          type: Types.SELECT_MESSAGE_ARRAY,
          payload: {
            selectMessageData: fileArray
          }
        });
      }
    }

    let hoverdiv: HTMLElement | any = document.getElementById("frezsec") || null;

    let hoverelement: HTMLElement | any = document.getElementById(data.id) || null;

    if (hoverelement != null) {
      hoverelement.classList.remove("highlighthover");
    }

    setHoverVisible(false);

    if (hoverdiv) hoverdiv.style["display"] = "none";

    let element: HTMLElement | any = document.getElementById("chatWindow") || null;
    element.style["overflow"] = "scroll";
    if (element != null) {
      if (element.hasAttribute("scroll") === true) {
        element.removeAttribute("scroll");
        element.style["overflow-y"] = "overlay";
      }
    }
  };

  const openShareWindow = () => {
    if (!chatReducer?.isDelete && !chatReducer?.isForward) {
      ChatService.onChangeForwardWindow(true,'single');
      let deletedArray: any = chatReducer?.selectMessageData;
      deletedArray?.push(data);
      let fileArray: any =
      ( data?.message?.messageType === "IMAGE" && data.message.body.fileType !== "image/webp") || data?.message?.messageType === "FILE" ? multiFile : deletedArray;
      store.dispatch({
        type: Types.SELECT_MESSAGE_ARRAY,
        payload: {
          selectMessageData: fileArray
        }
      });
    }

    let hoverdiv: HTMLElement | any = document.getElementById("frezsec") || null;

    let hoverelement: HTMLElement | any = document.getElementById(data.id) || null;

    if (hoverelement != null) {
      hoverelement.classList.remove("highlighthover");
    }

    setHoverVisible(false);

    if (hoverdiv) hoverdiv.style["display"] = "none";

    let element: HTMLElement | any = document.getElementById("chatWindow") || null;

    if (element != null) {
      if (element.hasAttribute("scroll") === true) {
        element.removeAttribute("scroll");
        element.style["overflow-y"] = "overlay";
      }
    }
  };

  const handleBlur = () => {
    console.log("handleBlur");
  };

  const openChatMore = () => {
    props?.highlightHover();
    let element: HTMLElement | any = document.getElementById("chatWindow") || null;
    let hoverelement: HTMLElement | any = document.getElementById(data.id) || null;

    if (element != null )  {
      if (element.hasAttribute("scroll") === true) {
        element.removeAttribute("scroll");

        setHoverVisible(false);

        let hoverdiv: HTMLElement | any = document.getElementById("frezsec") || null;

        if (hoverdiv) hoverdiv.style["display"] = "none";
        element.style["overflow-y"] = "overlay";
        if (hoverelement != null) {
          hoverelement.classList.remove("highlighthover");
        }
      
          var srcele = isMySpace?"unset":"scroll"
        element.style["overflow"] = srcele;
      } else {
        element.setAttribute("scroll", "no");

        setHoverVisible(true);
        let hoverdiv: HTMLElement | any = document.getElementById("frezsec") || null;

        if (hoverdiv) hoverdiv.style["display"] = "block";
        var srcele = isMySpace?"unset":"hidden"
        element.style["overflow"] = srcele;
      }
    }
  };

  const saveMessage = (status: any) => {
    if(status===1){
      toastInformation("Messsage Saved Successfully");
    }
    let isBookmark = {
      id: data.id,
      saveStatus: status
    };
    let hoverdiv: HTMLElement | any = document.getElementById("frezsec") || null;

    let hoverelement: HTMLElement | any = document.getElementById(data.id) || null;

    if (hoverelement != null) {
      hoverelement.classList.remove("highlighthover");
    }

    setHoverVisible(false);

    if (hoverdiv) hoverdiv.style["display"] = "none";

    let element: HTMLElement | any = document.getElementById("chatWindow") || null;

    if (element != null) {
      if (element.hasAttribute("scroll") === true) {
        element.removeAttribute("scroll");
        element.style["overflow-y"] = "overlay";
      }
    }
    socketService.current.bookMarkMesseage(isBookmark);
    status === 1 && toastInformation('Sucess! Message saved','success');
    status !== 1 && toastInformation('Message is now unsaved','success');
  };
  const saveallMessage = () => {
    for(var i=0;i<multiFile.length;i++){
      let isBookmark: any = multiFile[i]?.message?.isSave || [];
      let savedBookmark = (isBookmark && isBookmark["s" + userdetails?.sip_login_id]) || 0;
      let issBookmark = {
        id: multiFile[i].id,
        saveStatus: savedBookmark === 0?1:0
      };
      socketService.current.bookMarkMesseage(issBookmark);
    }
    toastInformation('Sucess! Message saved','success');
  }
  const likeMessage = (likeData: any) => {
    let input = {
      id: data.id,
      likeStatus: likeData
    };
    let hoverdiv: HTMLElement | any = document.getElementById("frezsec") || null;

    let hoverelement: HTMLElement | any = document.getElementById(data.id) || null;

    if (hoverelement != null) {
      hoverelement.classList.remove("highlighthover");
    }

    setHoverVisible(false);

    if (hoverdiv) hoverdiv.style["display"] = "none";

    let element: HTMLElement | any = document.getElementById("chatWindow") || null;

    if (element != null) {
      if (element.hasAttribute("scroll") === true) {
        element.removeAttribute("scroll");
        element.style["overflow-y"] = "overlay";
      }
    }

    socketService.current.likeMessageInfo(input);
    var inputRes: any = document.getElementById("textedited");
    if (input !== null && chatWindowDetails?.is_blocked !== 1) {
      inputRes.focus();
    }
  };
const downloadallMessage = ()=>{
  compressed_img(multiFile,"fileee")
  
}
const downloadAlfilesfromAttach = () =>{
  downloadAttachment(data);
 
};

  const dataMesg = data?.message;

  let content: any = (
    <>
      {
        <div className="popOverContainer">
          <div className="listdrapdrop">
            {Array.isArray(multiFile) && multiFile?.length >3 ?
            <ul className="orderItem">
                 <li>
                    <a href="#/" onClick={() => downloadallMessage()}>
                      Download all
                    </a>
                  </li>
               <li>
                    <a href="#/" onClick={() => saveallMessage()}>
                    {savedBookmark === 0 ?  "Save all" : "UnSave all"}
                    </a>
                  </li>
                  {(data?.message?.messageType === "TEXT" ||
                data?.message?.messageType === "FILE" ||
                data?.message?.messageType === "IMAGE" ||
                data?.message?.messageType === "MENTION") &&
                data?.direction === "OUT" &&
                !isNewMessageWindow &&
                chatWindowDetails?.sip_login_id !== userdetails?.sip_login_id && (
                  <li>
                    <a href="#/" onClick={() => deleteMessage()}>
                      Delete all
                    </a>
                  </li>
                )}
            </ul>
            :
            <ul className="orderItem">
              {chatWindowDetails?.team_id && data.direction === "OUT" && (
                  <li>
                  <a href="#/" onClick={() => openReadWindow()}>
                          Message Info
                    </a>
                  </li>
               
              )}
               {(data?.message?.messageType === "TEXT" || data?.message?.messageType === "AT_MENTION" || (data?.message?.messageType === "IMAGE" && data?.message?.body?.text !== "" && data?.message?.body?.text !== undefined ) ) && 
data?.direction === "OUT" &&chatWindowDetails?.is_blocked !== 1 && (
                  <li>
                    <a href="#/" onClick={() => openEditWindow()}>
                      Edit
                    </a>
                  </li>
                )}
              {/* <li> 
              <a href="#/" onClick={()=>likeMessage(isLike === 0 ? 1 : 0)}>{isLike === 0 ? 'Like' : 'Unlike'}</a>
            </li> */}
          
            {strickerFormat.indexOf(dataMesg?.body?.fileType) !== -1 && <><li>
                <a href="#/" onClick={() => openReplyMessage()}>
                  {"Reply"}
                </a>
              </li>
              <li>
                <a href="#/" onClick={() => likeMessage(isLike === 0 ? 1 : 0)}>
                  {isLike === 0 ? "Like" : "Unlike"}
                </a>
              </li>
              <li>
                <a href="#/"  onClick={openShareWindow}>
                  {"Forward"}
                </a>
              </li></> }
              <li>
                <a href="#/" onClick={() => saveMessage(savedBookmark === 0 ? 1 : 0)}>
                  {savedBookmark === 0 ? "Save Chat" : "UnSave chat"}
                </a>
              </li>
              {(
                data?.message?.messageType === "FILE" ||
                data?.message?.messageType === "IMAGE") && (
                  <li>
                    <a href="#/" onClick={() => downloadAlfilesfromAttach()}>
                      Download
                    </a>
                  </li>
                )}
              {(data?.message?.messageType === "TEXT" ||
                data?.message?.messageType === "FILE" ||
                data?.message?.messageType === "IMAGE" ||
                data?.message?.messageType === "AT_MENTION") &&
                data?.direction === "OUT" &&
              (
                  <li>
                    <a href="#/" onClick={() => deleteMessage()}>
                      Delete
                    </a>
                  </li>
                )}
                   {(data?.message?.messageType === "TEXT" ||
                data?.message?.messageType === "FILE" ||
                data?.message?.messageType === "IMAGE" ||
                data?.message?.messageType === "AT_MENTION") &&
                !isNewMessageWindow &&
                chatWindowDetails.sip_login_id !== userdetails.sip_login_id && (
                  <li>
                    <a href="#/" onClick={() => selectMessage()}>
                      Select Message
                    </a>
                  </li>
                )}
            </ul>
             }
          </div>
        </div>
      }
    </>
  );
  const openReadWindow = () => {
    chatSideWindow(true, "readreceipt", data);
    let hoverdiv: HTMLElement | any = document.getElementById("frezsec") || null;

    let hoverelement: HTMLElement | any = document.getElementById(data.id) || null;

    if (hoverelement != null) {
      hoverelement.classList.remove("highlighthover");
    }
    setHoverVisible(false);
    if (hoverdiv) hoverdiv.style["display"] = "none";
    let element: HTMLElement | any = document.getElementById("chatWindow") || null;

    if (element != null) {
      if (element.hasAttribute("scroll") === true) {
        element.removeAttribute("scroll");
        element.style["overflow-y"] = "overlay";
      }
    }
  };
  let teamMemberOnly = chatWindowDetails?.team_members
    ? chatWindowDetails?.team_members.split(",").map((ele: any) => ele.trim())
    : [];
  return (
    <>
     {props.replyHover ? (
        <ul className={className} {...restProps}>
          {!dataMesg.isDelete && (
            <Tooltip
              mouseEnterDelay={0.5}
              title={savedBookmark === 0 ? "Save Chat" : "UnSave chat"}
              className="cusTooltip"
              overlayClassName="customTooltip"
            >
              <li onClick={() => saveMessage(savedBookmark === 0 ? 1 : 0)}>
                <span className={savedBookmark === 0 ? "toSave" : "toUnSave"}></span>
              </li>
            </Tooltip>
          )}
          {!dataMesg.isDelete && (
            <Tooltip
              mouseEnterDelay={0.5}
              title={isLike === 0 ? "Like" : "Unlike"}
              className="cusTooltip"
              overlayClassName="customTooltip"
            >
              <li onClick={() => likeMessage(isLike === 0 ? 1 : 0)}>
                <span className="iconLike"></span>
              </li>
            </Tooltip>
          )}

          {(dataMesg?.messageType === "TEXT" || dataMesg?.messageType === "AT_MENTION") &&
            !dataMesg.isDelete &&
            data?.direction === "OUT" && (
              <Tooltip mouseEnterDelay={0.5} title="Edit" className="cusTooltip" overlayClassName="customTooltip">
                <li onClick={() => openEditWindow()}>
                  <span className="icon_edit"></span>
                </li>
              </Tooltip>
            )}
        </ul>
      ) : (
        <ul className={className} {...restProps}>
          {
            <Tooltip
              mouseEnterDelay={0.5}
              title={savedBookmark === 0 ? "Save Chat" : "UnSave chat"}
              className="cusTooltip"
              overlayClassName="customTooltip"
            >
              {/* <li onClick={() => saveMessage(savedBookmark === 0 ? 1 : 0)}>
                <span className={savedBookmark === 0 ? "toSave" : "toUnSave"}></span>
              </li> */}
            </Tooltip>
          }

          {(dataMesg?.messageType === "TEXT" ||
            dataMesg?.messageType === "IMAGE" ||
            dataMesg?.messageType === "FILE" ||
            dataMesg?.messageType === "AT_MENTION" ||dataMesg?.messageType === "NOTE" ||
            dataMesg?.messageType === "GEO") && strickerFormat.indexOf(dataMesg?.body?.fileType) === -1 &&
            teamMemberOnly &&
            Array.isArray(teamMemberOnly) &&
            (teamMemberOnly.includes(userdetails?.sip_login_id.toString().trim()) || chatWindowDetails?.sip_login_id) && (
              chatReducer?.isForward !==true &&  chatReducer?.isDelete !==true && chatReducer?.multiOption !==true && chatReducer?.replyMessageDetails?.isReply!==true &&   
              chatWindowDetails?.is_blocked !== 1 &&  
              <Tooltip mouseEnterDelay={0.5} title="Reply" className="cusTooltip" overlayClassName="customTooltip">
                  <li onClick={() => openReplyMessage()}>
                  <span className="iconReply"></span>
                </li>
              </Tooltip>
            )}
            { teamMemberOnly  && ((Array.isArray(multiFile) && multiFile.length <3 ) || dataMesg?.messageType === "TEXT") && 
            Array.isArray(teamMemberOnly) && strickerFormat.indexOf(dataMesg?.body?.fileType) === -1 &&
            (teamMemberOnly.includes(userdetails?.sip_login_id.toString().trim()) || chatWindowDetails?.sip_login_id) && (
              chatReducer?.isForward !==true &&  chatReducer?.isDelete !==true && chatReducer?.multiOption !==true && chatReducer?.replyMessageDetails?.isReply!==true &&
              <Tooltip mouseEnterDelay={0.5} title={isLike === 0 ? "Like" : "Unlike"} className="cusTooltip" overlayClassName="customTooltip">
           <li onClick={() => likeMessage(isLike === 0 ? 1 : 0)}>
            <span className="iconLike"></span>
          </li>
          </Tooltip>
            )}
          {(dataMesg?.messageType === "TEXT" ||
            dataMesg?.messageType === "IMAGE" ||
            dataMesg?.messageType === "FILE" ||
            dataMesg?.messageType === "AT_MENTION") && strickerFormat.indexOf(dataMesg?.body?.fileType) === -1 &&
             ( chatReducer?.isForward !==true &&  
              chatReducer?.isDelete !==true && chatReducer?.multiOption !==true && chatReducer?.replyMessageDetails?.isReply!==true &&
              <Tooltip mouseEnterDelay={0.5} title="Share" className="cusTooltip" overlayClassName="customTooltip">
               <li onClick={openShareWindow}>
                  <span className="iconShare"></span>
                </li>
              </Tooltip>
            )}

          {teamMemberOnly &&
            Array.isArray(teamMemberOnly) &&
            (teamMemberOnly?.includes(userdetails?.sip_login_id?.toString()?.trim()) ||
              chatWindowDetails?.sip_login_id) && (
              <Tooltip mouseEnterDelay={0.5} title="More" className="cusTooltip" overlayClassName="customTooltip">
                <Popover
                  placement="bottomRight"
                  content={chatReducer.isForward !==true &&  chatReducer.isDelete !==true   && chatReducer?.multiOption !==true && chatReducer?.replyMessageDetails?.isReply!==true && content}
                  overlayClassName="customEditdrop"
                  trigger="click"
                  onVisibleChange={openChatMore}
                  visible={hovervisible}
                  id={data?.id}
                >
                 {chatReducer?.isForward !==true &&  chatReducer?.isDelete !==true && chatReducer?.multiOption !==true &&chatReducer?.replyMessageDetails?.isReply!==true && <li>
                    <span className="iconOverflow" onBlur={handleBlur}></span>
                  </li>}
                </Popover>
              </Tooltip>
            )}
        </ul>
      )}
    </>
  );
}

ChatHoverOption.propTypes = {
  className: PropTypes.any
};
